export function Logo3DFallback({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`flex items-center justify-center w-full h-full ${className}`}
    >
      <svg
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <defs>
          <linearGradient id="ng-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2dd4bf" />
            <stop offset="100%" stopColor="#0891b2" />
          </linearGradient>
          <filter id="ng-glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <radialGradient id="ng-bg" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#0d1525" />
            <stop offset="100%" stopColor="#050a14" />
          </radialGradient>
        </defs>

        {/* Background disc */}
        <circle cx="100" cy="100" r="96" fill="url(#ng-bg)" />

        {/* Outer rings */}
        <circle cx="100" cy="100" r="90" stroke="url(#ng-grad)" strokeWidth="1" strokeOpacity="0.25" fill="none" />
        <circle cx="100" cy="100" r="76" stroke="url(#ng-grad)" strokeWidth="0.5" strokeOpacity="0.12" fill="none" />

        {/* Corner accent dots */}
        <circle cx="55" cy="58" r="3.5" fill="#2dd4bf" fillOpacity="0.9" filter="url(#ng-glow)" />
        <circle cx="145" cy="58" r="3.5" fill="#0891b2" fillOpacity="0.9" filter="url(#ng-glow)" />
        <circle cx="55" cy="142" r="3.5" fill="#2dd4bf" fillOpacity="0.9" filter="url(#ng-glow)" />
        <circle cx="145" cy="142" r="3.5" fill="#0891b2" fillOpacity="0.9" filter="url(#ng-glow)" />

        {/* N letter — stroke path */}
        <path
          d="M55 142 L55 58 L145 142 L145 58"
          stroke="url(#ng-grad)"
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          filter="url(#ng-glow)"
        />
      </svg>
    </div>
  );
}
